// extracted by mini-css-extract-plugin
export var checkbox = "_8d-0";
export var circle = "_8d-3";
export var horizontalContainer = "_8d-7";
export var sm = "_8d-5";
export var switch0 = "_8d-2";
export var switchDisabled = "_8d-8";
export var switchEnabled = "_8d-1";
export var textSwitchContainer = "_8d-9";
export var textSwitchOption = "_8d-a";
export var textSwitchOptionSelected = "_8d-b";
export var verticalContainer = "_8d-6";
export var xs = "_8d-4";